// extracted by mini-css-extract-plugin
export default {"controls":"add-service-modal_controls__4lgPs","button":"add-service-modal_button__q7AaA"};